module.exports = __webpack_public_path__ + "static/media/nav_arrow_right.61620924.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav_arrow_right.svg
// module id = 881
// module chunks = 3